// extracted by mini-css-extract-plugin
export default {"container":"EnterAppInfo_container__qyHY4","menuBar":"EnterAppInfo_menuBar__WuGjb","submitButton":"EnterAppInfo_submitButton__VbxyP"};